export default __webpack_public_path__ + "static/media/volumetric-box.f2c3eacf.png";